var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 2000 2000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f3ba2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m611.59 840.42l388.4-388.39 388.6 388.59 226-226-614.6-614.62-614.39 614.42 225.99 226"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.70711-.70711.70711.70711-640.89 452.68)",
    d: "m66.19 840.17h319.62v319.6h-319.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.59 1159.58l388.4 388.39 388.59-388.58 226.12 225.88-.11.12-614.6 614.61-614.41-614.4-.32-.32 226.33-225.7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.70711-.70711.70711.70711-187.56 1547.34)",
    d: "m1614.19 840.27h319.62v319.6h-319.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229.22 999.88h.1l-229.33-229.33-169.48 169.48h-.01l-19.47 19.48-40.16 40.17-.32.31.32.33 229.12 229.13 229.33-229.33.11-.13-.21-.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.6cc685a6e4bef1cd26ddd72f1fe41eb3.svg";
export { ForwardRef as ReactComponent };